import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/**
 * @file Created on Mon Nov 2 2020
 * @author ICe
 * @author JPk
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { jsonConversions, UserInfoConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { Map } from 'immutable';
export var WorkflowCasesLayer = function WorkflowCasesLayer() {
  var _this = this;

  _classCallCheck(this, WorkflowCasesLayer);

  /**
   * Refresh the workspace case lock
   * @param caseIds {string[]}- Workflow case IDs
   */
  this.refreshLock = function (caseIds) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var apiConfig;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              apiConfig = {
                responseType: 'json'
              };
              _context.prev = 1;
              _context.next = 4;
              return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.WORKFLOW_CASES_LOCK_REFRESH)).post({
                caseIds: caseIds
              }, apiConfig);

            case 4:
              _context.next = 10;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](1);
              logger.error(_context.t0);
              return _context.abrupt("return", Promise.reject(_context.t0));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 6]]);
    }));
  };
  /**
   * Gets assignees (or null) of given workflow cases.
   * @param caseIds {List<string>}- Workflow case IDs
   */


  this.getWFCasesAssignees = function (caseIds) {
    return __awaiter(_this, void 0, void 0,
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _this2 = this;

      var apiConfig, result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              apiConfig = {
                responseType: 'json'
              };
              _context2.prev = 1;
              _context2.next = 4;
              return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.WORKFLOW_CASES_ASSIGNEES)).post({
                caseIds: caseIds.toArray()
              }, apiConfig);

            case 4:
              result = _context2.sent;
              return _context2.abrupt("return", Map(Object.keys(result.data).map(function (caseId) {
                return [caseId, result.data[caseId] ? _this2.userInfoConverter.toObject(result.data[caseId], jsonConversions) : null];
              })));

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              logger.error(_context2.t0);
              return _context2.abrupt("return", Promise.reject(_context2.t0));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    }));
  };
};

__decorate([Inject, __metadata("design:type", UserInfoConverter)], WorkflowCasesLayer.prototype, "userInfoConverter", void 0);